/** @deprecated */

import { ElementRef, Renderer2, RendererStyleFlags2 } from '@angular/core';

// dynamic width for queue dropdown
export function adjustDropdownWidth(
    renderer: Renderer2,
    dropdownRef: ElementRef,
): void {
    const dropdownPanel =
        dropdownRef.nativeElement.querySelector('select-dropdown');
    if (!dropdownPanel) {
        return;
    }

    // temporary element for measuring text width using Renderer2
    const measurer = renderer.createElement('span');
    renderer.setStyle(measurer, 'position', 'absolute');
    renderer.setStyle(measurer, 'whiteSpace', 'nowrap');
    renderer.setStyle(measurer, 'visibility', 'hidden');
    renderer.appendChild(document.body, measurer);

    let maxWidth = 0;
    const listItems = dropdownPanel.querySelectorAll('ul li span');

    listItems.forEach((span) => {
        renderer.setProperty(measurer, 'textContent', span.textContent);
        const width = measurer.getBoundingClientRect().width;
        maxWidth = Math.max(maxWidth, width);
    });

    renderer.removeChild(document.body, measurer);

    if (maxWidth > 0) {
        maxWidth = maxWidth + 20; // buffer width;
        const desiredWidth = `${maxWidth}px`;
        applyStyles(renderer, dropdownPanel, 'inline-block', desiredWidth);
        const allDivs = dropdownPanel.querySelectorAll('div');
        allDivs.forEach((div) =>
            applyStyles(renderer, div, 'inline-block', '100%'),
        );
    }
}

function applyStyles(
    renderer: Renderer2,
    element: any,
    display: string,
    width: string,
): void {
    renderer.setStyle(
        element,
        'display',
        display,
        RendererStyleFlags2.Important,
    );
    renderer.setStyle(element, 'width', width, RendererStyleFlags2.Important);
}
